// @flow

import React, { Component } from 'react';
import {colorbrewer} from './3rd/custom_colorbrewer.js';
import _ from 'lodash';

import {gen_snum} from './utils.js';

import './css/EscalaDiff.css';


type T_EscalaDiffProps = {
  gmax: number
};



const colors = colorbrewer['RdBu'][11].slice().reverse(),
      snum   = gen_snum(2);


export default class EscalaDiff extends Component<T_EscalaDiffProps> {
  step: number = (2 * this.props.gmax) / 11;
  
  
  value = (index: number): [number, number] => {
    const to   = this.props.gmax - (index * this.step),
          from = to - this.step;
    
    return [from, to];
  }
  
  
  row = (index: number) => {
    const [from, to] = this.value(index);
    
    return (
      <tr key={index}>
        <td className='diff_col' style={{backgroundColor: colors[index]}}>&nbsp;</td>
        <td className='diff_num'><span>{snum(from)}</span></td>
        <td className='diff_mid'>–</td>
        <td className='diff_num'><span>{snum(to)}</span></td>
      </tr>
    );
  }
  
  
  
  render() {
    return (
      <div className='EscalaDiff'>
        %
        <table className='EscalaDiff'>
          <tbody>
            {_.range(0,11).map(this.row)}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/EscalaDiff.jsx